
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";

interface UserListingsHeaderProps {
  canAddNewListing: boolean;
  statusFilter: "all" | "pending" | "approved" | "rejected";
  onStatusFilterChange: (value: "all" | "pending" | "approved" | "rejected") => void;
  showTitle?: boolean;
}

export const UserListingsHeader = ({ canAddNewListing, statusFilter, onStatusFilterChange, showTitle = true }: UserListingsHeaderProps) => {
  const { t } = useTranslation('common');
  
  return (
    <div className="mb-6 flex flex-col items-start justify-between gap-4 rounded-md border border-brand-cloud bg-white p-4 shadow-sm sm:flex-row sm:items-center">
      {showTitle ? (
        <div>
          <h1 className="public-section-title">{t("listings.title")}</h1>
          <p className="mt-1 text-brand-slate">
            {t("listings.description")}
          </p>
        </div>
      ) : (
        <div />
      )}
      
      <div className="flex flex-wrap items-center gap-2">
        {/* Show Add New Listing button (disabled if they can't add more) */}
        <Button 
          className="flex items-center gap-1 bg-brand-ink text-white hover:bg-brand-charcoal"
          disabled={!canAddNewListing}
          asChild={canAddNewListing}
        >
          {canAddNewListing ? (
            <Link to="/submit-listing">
              <Plus className="h-4 w-4" />
              {t("listings.addNewListing")}
            </Link>
          ) : (
            <>
              <Plus className="h-4 w-4" />
              {t("listings.addNewListing")}
            </>
          )}
        </Button>
        
        <Select value={statusFilter} onValueChange={onStatusFilterChange}>
          <SelectTrigger className="w-[140px]">
            <SelectValue placeholder="Filter by status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">{t("listings.filters.all")}</SelectItem>
            <SelectItem value="pending">{t("listings.filters.pending")}</SelectItem>
            <SelectItem value="approved">{t("listings.filters.approved")}</SelectItem>
            <SelectItem value="rejected">{t("listings.filters.rejected")}</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
